module.exports = "<div class=\"dialog-contents\">\n    <h2 class=\"\"></h2>\n    <div class=\"ngdialog-buttons\" style=\"text-align: center; height: auto\">\n        <button style=\"display: inline-block;\" type=\"button\" class=\"btn btn-default ngdialog-button close-dialog\" ng-click=\"closeThisDialog()\">{{ \"CLOSE\" | translate }}</button>\n    </div>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./dash_board/template/en/modal_question-and-answers.html
 ** module id = 38
 ** module chunks = 0
 **/